import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/common/Button';

import Image from 'global/Image';
import { ModalConfirmation } from './styled';

const ModalBlockedReqOTP = ({
  visible = false,
  title = '',
  submitText = 'Back to Settings',
  onBack = () => {},
}) => (
  <ModalConfirmation
    visible={visible}
    centered
    width="400px"
    closeIcon={<div />}
    onCancel={onBack}
  >
    {/* @ts-expect-error */}
    <Flex align="center" direction="column" py="30px">
      <Image
        src="/icon/password-otp-locked.svg"
        alt="lock"
        style={{ marginBottom: '18px' }}
      />
      <Text weight="700" size="16px" height="26px">
        {title}
      </Text>
      <Text weight="400" size="14px" height="22px">
        You’ve reached the limit of verification code requests.
      </Text>
    </Flex>

    <Button
      type="primary"
      width="160px"
      height="40px"
      radius="4px"
      onClick={onBack}
      // @ts-expect-error
      mx="auto"
    >
      <b>{submitText}</b>
    </Button>
  </ModalConfirmation>
);

export default ModalBlockedReqOTP;
